import React, { ReactNode } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useThemeColors } from '../../hooks/useThemeColors';

interface ThemeProviderProps {
  children: ReactNode;
}

const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  const { user } = useAuth();
  useThemeColors({ preferences: user?.preferences || null });
  return <>{children}</>;
};

export default ThemeProvider;
